/** 総合判定結果 */
export const OVERALL_RESULT_VALUES = {
  /** 調査済(Aランク) */
  RANK_A: '1',
  /** 要注意(Bランク) */
  RANK_B: '2',
  /** 危険(Cランク) */
  RANK_C: '3'
} as const
